import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true, // send session_token cookie
});

export const API_BASE = `${BACKEND_URL}/api`;
